import React from 'react';
import { Icon, IconName, Scale, Typography, TypographyVariant } from '@secretescapes/falcon';
import { CloseButtonContainer } from '@features/Sale/Details/Details.styles';
import { StyledModal, StyledModalHeader } from '@features/Sale/SalePageModal/SalePageModal.styles';

enum CloseButtonVariant {
  MODEL_CLOSE_BUTTON = 'MODEL_CLOSE_BUTTON',
  SEPERATE_BUTTON_CONTAINER = 'SEPERATE_BUTTON_CONTAINER',
}

interface IModalProps {
  content?: React.ReactElement | string;
  isOpen: boolean;
  onClose: () => void;
  modalTitle?: string;
  closeButtonVariant?: CloseButtonVariant;
  withPortal?: boolean;
}

export const SalePageModal = ({
  onClose,
  isOpen,
  content,
  modalTitle,
  closeButtonVariant = CloseButtonVariant.SEPERATE_BUTTON_CONTAINER,
  withPortal,
}: IModalProps) => {
  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onClose}
      withCloseButton={closeButtonVariant === CloseButtonVariant.MODEL_CLOSE_BUTTON}
      container={withPortal ? document.body : undefined}
    >
      <div>
        {modalTitle && (
          <StyledModalHeader variant={TypographyVariant.t3}>{modalTitle}</StyledModalHeader>
        )}
        {typeof content === 'string' ? (
          <Typography allowDangerousRender={true} variant={TypographyVariant.body}>
            {content}
          </Typography>
        ) : (
          content
        )}
      </div>
      {closeButtonVariant === CloseButtonVariant.SEPERATE_BUTTON_CONTAINER && (
        <CloseButtonContainer onClick={onClose}>
          <Icon dataAttributes={{ testid: 'closeButton' }} name={IconName.close} size={Scale.m} />
        </CloseButtonContainer>
      )}
    </StyledModal>
  );
};
